import MuiListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

export default MuiListItemSecondaryAction;
